// @ts-nocheck
/** Short, non-cryptographic 32-bit string hash (base 36) for change detection, not for security. */
const hashString = (text: string) => {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
        hash = (hash * 31 + text.charCodeAt(i)) % 4294967296;
    }

    return hash.toString(36);
};

export default hashString;
